module.exports = __webpack_public_path__ + "img/Lea.08a26178.gif";